// extracted by mini-css-extract-plugin
export default {"quiz":"LayoutQuiz_quiz__J9IyR","recording":"LayoutQuiz_recording__i49v2","active":"LayoutQuiz_active__HZe4U"};